export const search = {
  headerTitle: "検索",
  section: {
    status: "女性の状態",
    callType: "通話許可",
    recentVideoCall: "今すぐビデオ通話",
    lovense: "Lovense（遠隔バイブ操作）",
    minReviewScore: "おすすめ度",
    age: "年齢",
    area: "エリア",
    bustSize: "バストサイズ",
    bodyType: "好きな女性のタイプ",
    maritalStatus: "婚姻状況",
    fleaMarket: "フリマ出品",
    nickname: "ニックネーム検索",
  },
  status: {
    all: "全ての女性",
    new: "新人女性",
  },
  callType: {
    noPreference: "指定なし",
    video: "ビデオ通話可能",
    voice: "音声通話可能",
  },
  recentVideoCall: {
    noPreference: "指定なし",
    available: "今すぐ通話可能",
  },
  lovense: {
    noPreference: "指定なし",
    has: "あり",
  },
  minReviewScore: {
    none: "なし",
    over: (args: { score: string | number }) => `★${args.score}以上`,
    only5: "★5のみ",
  },
  age: {
    noPreference: "指定なし",
    under20: "~20歳",
    "21to25": "21~25歳",
    "26to30": "26~30歳",
    "31to35": "31~35歳",
    "36to40": "36~40歳",
    "41to45": "41~45歳",
    over46: "46歳~",
  },
  area: {
    noPreference: "指定なし",
    hokkaido: "北海道",
    tohoku: "東北",
    kanto: "関東",
    chubu: "中部",
    kansai: "関西",
    chugoku: "中国",
    shikoku: "四国",
    kyushuOkinawa: "九州・沖縄",
  },
  bustSize: {
    noPreference: "指定なし",
    aCup: "Aカップ",
    bCup: "Bカップ",
    cCup: "Cカップ",
    dCup: "Dカップ",
    eCup: "Eカップ",
    bigBreasts: "Fカップ以上",
  },
  bodyType: {
    slender: "スレンダー",
    petite: "小柄",
    somewhatSlender: "ややスレンダー",
    normal: "普通",
    chubby: "ぽっちゃり",
    glamorous: "グラマー",
    somewhatChubby: "ややぽっちゃり",
    sexy: "セクシー",
    verySlender: "かなりスレンダー",
    tall: "長身",
    marshmallow: "マシュマロ",
  },
  maritalStatus: {
    noPreference: "指定なし",
    unmarried: "未婚",
    married: "既婚",
  },
  fleaMarket: {
    noPreference: "指定なし",
    listed: "出品中",
  },
  nicknamePlaceholder: "ニックネームを入力してください",
  multiSelect: "複数選択可",
  actions: {
    search: "検索する",
    reset: "検索条件をリセット",
  },
  result: {
    title: "検索結果",
    empty: "ユーザーが見つかりませんでした",
    changeFilter: "検索条件を変更",
  },
} as const;
